// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menu-item_menuItem__m-WEq","left":"menu-item_left__2PfGW","on":"menu-item_on__2C7WQ"};